import { computed, inject, Service } from '@angular/core';
import { demoProgrammIds, IGesundheitsProgrammInfo } from '@mng/mgs-lib';
import { ProgrammService } from '../../programm/programm.service';
import { MgsWebApi } from '../../mgs-webapi.service';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { MngMessageService } from '@mng/mng-message-handler';
import { MngDialogService } from '@mng/mng-inputs';
import { AuthStateFacade } from '../../auth/auth-state.facade';

@Service()
export class DienstleistungDemoService {
  readonly webApi = inject(MgsWebApi);
  readonly authState = inject(AuthStateFacade);
  readonly router = inject(Router);
  readonly programmService = inject(ProgrammService);
  readonly messageService = inject(MngMessageService);
  readonly dialogService = inject(MngDialogService);
  aktiveDemoProgramme = computed<IGesundheitsProgrammInfo[]>(() => {
    let result: IGesundheitsProgrammInfo[];
    if (!this.authState.isAdmin() && !this.authState.isBuchungszentraleUser()) {
      result =
        this.programmService
          .partnerProgramme()
          ?.filter((programm) => !programm.inaktiv && demoProgrammIds.includes(programm.id)) ?? [];
    } else {
      result = this.programmService.demoProgramme();
    }
    return result;
  });

  async resetDemoProgramme() {
    const htmlContent = `Möchten Sie die Demo Programme <strong>zurücksetzen</strong>?<br><br><br>Sie können danach mit neuen Demo Programmen fortfahren...`;
    this.dialogService.showYesNo({ htmlContent }, async () => {
      await firstValueFrom(this.webApi.demoDienstleistungenLoeschen());
      void this.messageService.showMessage('Demo Programme wurden zurückgesetzt');
    });
  }
}
